import { Collection } from 'modules/core/lib/mobx-rest'

import CallRequest from 'modules/onboarding/store/models/CallRequest'

class CallRequests extends Collection<CallRequest> {
  get cacheKey(): string {
    return 'callRequests'
  }

  model() {
    return CallRequest
  }
}

const singleton: CallRequests = new CallRequests()

export default singleton
